const invertedMessages = {
  More: 'CERTS_BULK_MORE',
  Copilot: 'certs.copilot',
};

export default invertedMessages;
